interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
}

export const DatepickerIcon = ({
  width = 22,
  height = 22,
  hexColor = "#002E56",
}: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.1426 6.00028V0.857422" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 6.00028V0.857422" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.85742 6.00028V0.857422" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.57115 3.42969H21.4283C22.3751 3.42969 23.1426 4.19721 23.1426 5.14397V21.4297C23.1426 22.3765 22.3751 23.144 21.4283 23.144H2.57115C1.62435 23.144 0.856865 22.3765 0.856865 21.4297V5.14397C0.856865 4.19721 1.62435 3.42969 2.57115 3.42969Z" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DatepickerIcon;
